// extracted by mini-css-extract-plugin
module.exports = {"container":"Prepayment_container__2Gaz4","h3":"Prepayment_h3__1-1pR","list":"Prepayment_list__10Wuw","header":"Prepayment_header__ig1rb"};